import { UpdatePaymentApiTradesApi } from "@/features/accounts/payment/api/services/update-trades-api";
import { UpdatePaymentApiTradesPostRequestModel } from "@/features/accounts/payment/api/services/update-trades-model";

/// MoneyLook明細更新（API版）処理
export class UpdatePaymentApiTradesService {
  private updatePaymentApiTradesApi = new UpdatePaymentApiTradesApi();

  /**
   * MoneyLook明細更新（API版）API実行
   */
  public async updatePaymentApiTrades(param: UpdatePaymentApiTradesPostRequestModel) {
    return await this.updatePaymentApiTradesApi.updatePaymentApiTrades(param);
  }
}
